import { Button, Modal, Typography } from "antd";
import React, { useState } from "react";
import "./signup-docs.scss";
const ShowDetailedView = ({ organizationData }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(!open);
  };

  return (
    <div>
      <Button type="primary" onClick={handleOpen} size="small">
        Show Details
      </Button>
      <Modal
        title={`Status of form: ${"  "}${
          organizationData?.currentStage ? organizationData?.currentStage : "-"
        }`}
        open={open}
        onCancel={handleClose}
        footer={null}
      >
        <div>
          <div className="heading-details-signup">
            <Typography.Title level={5}>CKYC</Typography.Title>
          </div>
          <div className="ckyc-info-signup">
            <p>
              *PAN:{" "}
              {organizationData?.corporateKycDetails?.panNumber
                ? organizationData?.corporateKycDetails?.panNumber
                : "-"}
            </p>
            <p>
              *Legal Name:{" "}
              {organizationData?.corporateKycDetails?.legalName
                ? organizationData?.corporateKycDetails?.legalName
                : "-"}
            </p>
            <p>
              *CIN:{" "}
              {organizationData?.corporateKycDetails?.cin
                ? organizationData?.corporateKycDetails?.cin
                : "-"}
            </p>
            <p>
              *GST:{" "}
              {organizationData?.corporateKycDetails?.gstNumber
                ? organizationData?.corporateKycDetails?.gstNumber
                : "-"}
            </p>
            <p>
              *Company Type:{" "}
              {organizationData?.corporateKycDetails?.companyType
                ? organizationData?.corporateKycDetails?.companyType.replaceAll(
                    "_",
                    " "
                  )
                : "-"}
            </p>
            <p>
              * Nature Of Bussiness:{" "}
              {organizationData?.corporateKycDetails?.natureOfBussiness
                ? organizationData?.corporateKycDetails?.natureOfBussiness.replaceAll(
                    "_",
                    " "
                  )
                : "-"}
            </p>
            <p>
              *Premise:{" "}
              {organizationData?.corporateKycDetails?.premise
                ? organizationData?.corporateKycDetails?.premise
                : "-"}
            </p>
            <p>
              Lei :{" "}
              {organizationData?.corporateKycDetails?.leiNumber
                ? organizationData?.corporateKycDetails?.leiNumber
                : "-"}
            </p>
            <p>
              *Country Of Incorporation:{" "}
              {organizationData?.corporateKycDetails?.countryOfIncorporation
                ? organizationData?.corporateKycDetails?.countryOfIncorporation
                : "-"}
            </p>
            <p>
              *Place Of Incorporation:{" "}
              {organizationData?.corporateKycDetails?.placeOfIncorporation
                ? organizationData?.corporateKycDetails?.placeOfIncorporation
                : "-"}
            </p>
            <p>
              *Date Of Incorporation:{" "}
              {organizationData?.corporateKycDetails?.dateOfIncorporation
                ? organizationData?.corporateKycDetails?.dateOfIncorporation
                : "-"}
            </p>
            <p>
              *Annual Turnover:{" "}
              {organizationData?.corporateKycDetails?.annualTurnOver
                ? organizationData?.corporateKycDetails?.annualTurnOver
                : "-"}
            </p>
            <p>
              *Listed Company :{" "}
              {organizationData?.corporateKycDetails?.isListedCompany
                ? organizationData?.corporateKycDetails?.isListedCompany ===
                  true
                  ? "YES"
                  : "NO"
                : "-"}
            </p>
            <p>
              *Net Worth:{" INR "}
              {organizationData?.corporateKycDetails?.netWorth
                ? organizationData?.corporateKycDetails?.netWorth
                : "-"}
            </p>
            <p>
              *IEC:{"  "}
              {organizationData?.corporateKycDetails?.importExportCode
                ? organizationData?.corporateKycDetails?.importExportCode
                : "-"}
            </p>
            <p>
              *TAN:{"  "}
              {organizationData?.corporateKycDetails?.tan
                ? organizationData?.corporateKycDetails?.tan
                : "-"}
            </p>
            <p>
              *BUSSINESS ADDRESS:{"  "}
              {organizationData?.corporateKycDetails?.businessAddress ? (
                <div>
                  {
                    organizationData?.corporateKycDetails?.businessAddress
                      .addressLineOne
                  }
                  <br />

                  {
                    organizationData?.corporateKycDetails?.businessAddress
                      .addressLineTwo
                  }
                  <br />

                  {organizationData?.corporateKycDetails?.businessAddress.city}
                  <br />

                  {
                    organizationData?.corporateKycDetails?.businessAddress
                      .country
                  }
                  <br />

                  {organizationData?.corporateKycDetails?.businessAddress.state}
                  <br />

                  {
                    organizationData?.corporateKycDetails?.businessAddress
                      .pinCode
                  }
                </div>
              ) : (
                "-"
              )}
            </p>
            <p>
              *REGISTERED ADDRESS:{"  "}
              {organizationData?.corporateKycDetails?.registeredAddress ? (
                <div>
                  {
                    organizationData?.corporateKycDetails?.registeredAddress
                      .addressLineOne
                  }
                  <br />

                  {
                    organizationData?.corporateKycDetails?.registeredAddress
                      .addressLineTwo
                  }
                  <br />

                  {
                    organizationData?.corporateKycDetails?.registeredAddress
                      .city
                  }
                  <br />

                  {
                    organizationData?.corporateKycDetails?.registeredAddress
                      .country
                  }
                  <br />

                  {
                    organizationData?.corporateKycDetails?.registeredAddress
                      .state
                  }
                  <br />

                  {
                    organizationData?.corporateKycDetails?.registeredAddress
                      .pinCode
                  }
                </div>
              ) : (
                "-"
              )}
            </p>
            <div className="heading-details-signup">
              <Typography.Title level={5}>
                Authorized Signatories
              </Typography.Title>
            </div>
            <div className="auth-info-signup">
              {organizationData?.authorizedSignatories?.length > 0 ? (
                <>
                  {organizationData?.authorizedSignatories.map(
                    (auth, index) => {
                      return (
                        <div>
                          <h6> Authorized Signatory : {index + 1}</h6>
                          <p>*NAME: {auth?.name ? auth.name : "-"}</p>
                          <p>*EMAIL: {auth?.emailId ? auth.emailId : "-"}</p>
                          <p>
                            DESIGNATION:{" "}
                            {auth?.designation ? auth.designation : "-"}
                          </p>
                          <p>*PAN: {auth?.panNumber ? auth.panNumber : "-"}</p>
                          <p>*DIN: {auth?.din ? auth.din : "-"}</p>
                          <p>*DOB: {auth?.dob ? auth.dob : "-"}</p>
                          <p>
                            *PHONE: {auth?.phoneNumber ? auth.phoneNumber : "-"}
                          </p>
                          <p>
                            *MOTHER NAME:{" "}
                            {auth?.motherName ? auth.motherName : "-"}
                          </p>
                          <p>
                            *FATHER NAME:{" "}
                            {auth?.fatherName ? auth.fatherName : "-"}
                          </p>
                          <p>
                            *NATIONALITY:{" "}
                            {auth?.nationality ? auth.nationality : "-"}
                          </p>
                        </div>
                      );
                    }
                  )}
                </>
              ) : (
                "-"
              )}
            </div>
            <div className="heading-details-signup">
              <Typography.Title level={5}>Shareholders</Typography.Title>
            </div>
            <div className="shareholder-info-signup">
              {organizationData?.shareholders?.length > 0 ? (
                <>
                  {organizationData?.shareholders.map((shareholder, index) => {
                    return (
                      <div>
                        <h6> Shareholder : {index + 1}</h6>
                        <p>
                          *NAME: {shareholder?.name ? shareholder.name : "-"}
                        </p>
                        <p>
                          {shareholder?.idName
                            ? "*" + shareholder?.idName
                            : "IDNAME"}
                          : {shareholder?.idNumber ? shareholder.idNumber : "-"}
                        </p>
                        <p>
                          *Status:{" "}
                          {shareholder.isIndividual === true
                            ? "INDIVIDUAL"
                            : "NON-INDIVIDUAL"}
                        </p>
                        <p>
                          *PERCENTAGE (%):{" "}
                          {shareholder?.percentage
                            ? shareholder.percentage
                            : "-"}
                        </p>
                        <p>
                          REASON:{" "}
                          {shareholder?.reason ? shareholder.reason : "-"}
                        </p>
                        <p>*DOB: {shareholder?.dob ? shareholder.dob : "-"}</p>
                        <p>
                          *NATIONALITY:{" "}
                          {shareholder?.nationality
                            ? shareholder.nationality
                            : "-"}
                        </p>
                        <p>
                          *Residential Address:{<br />}
                          {shareholder.residentialAddress !== null ? (
                            <>
                              {shareholder.residentialAddress.addressLineOne}
                              <br />
                              {
                                shareholder.residentialAddress.addressLineTwo
                              }{" "}
                              <br />
                              {shareholder.residentialAddress.city} <br />
                              {shareholder.residentialAddress.state} <br />
                              {shareholder.residentialAddress.country} <br />
                              {shareholder.residentialAddress.pinCode}{" "}
                            </>
                          ) : (
                            "-"
                          )}
                        </p>
                      </div>
                    );
                  })}
                </>
              ) : (
                "-"
              )}
            </div>
            <div className="heading-details-signup">
              <Typography.Title level={5}>Declaration Form</Typography.Title>
            </div>
            <div className="declaration-info-signup">
              <p>
                *POA:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.grantedPOA === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Has Substantial USOwner:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.hasSubstantialUSOwner ===
                    true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Has US IncomeSource:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.hasUSIncomeSource === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Has US PhoneNumber:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.hasUSPhoneNumber === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Has US Residence Or MailingAddress:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm
                      .hasUSResidenceOrMailingAddress === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *In Care Of Or HoldMail US:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.inCareOfOrHoldMailUS ===
                    true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Is In Corporated In USA:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.isIncorporatedInUSA ===
                    true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Is Subsidiary Of US Company:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm
                      .isSubsidiaryOfUSCompany === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *SI To US:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.siToUS === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
              <p>
                *Taxable in US:
                {organizationData?.declarationForm
                  ? organizationData?.declarationForm.taxableInUS === true
                    ? " YES"
                    : " NO"
                  : "-"}
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ShowDetailedView;
